<template>
  <el-collapse
      v-model="activeNames"
      @change="handleChange">
    <el-collapse-item
        title="Battery"
        name="1">
      <div v-if="chartOptions.rssi.hasOwnProperty('chart')">
        <highcharts :options="chartOptions.battery" />
      </div>
    </el-collapse-item>
    <el-collapse-item
        title="RSSI"
        name="2">
      <highcharts :options="chartOptions.rssi" />
    </el-collapse-item>
    <el-collapse-item
        title="Stream Profile"
        name="3">
      <highcharts :options="chartOptions.stream" />
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import FromStatusReportsToChartData from "./helpers/FromStatusReportsToChartData";
import batteryChartOptions from "./helpers/BatteryChartOptions";
import RSSIChartOptions from "./helpers/RSSIChartOptions";
import StreamProfileChartOptions from "./helpers/StreamProfileChartOptions";
import { get } from "lodash";

export default {
  name: "StatusReportCharts",
  props: {
    reports: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      chartOptions: {
        stream: {},
        rssi: {},
        battery: {},
      },
      activeNames: [],
    };
  },
  computed: {
    deviceType() {
      return get(this.reports, "[0].type", "");
    },
    isChime() {
      return this.deviceType === "chime";
    },
    isDPD() {
      let status = get(this.reports, "[0].data.status", {});
      return status.hasOwnProperty("battery_percentage");
    },
    rssiUnit() {
      return this.isChime ? "Mgmnt RSSI" : "Unit RSSI";
    },
  },
  watch: {
    reports(value) {
      if (Array(value).length > 0) {
        this.prepareChartOptions();
      }
    },
  },
  created() {
    this.prepareChartOptions();
  },
  methods: {
    handleChange(val) {
      console.log(val);
    },
    prepareChartOptions() {
      let chartData = FromStatusReportsToChartData(this.reports);
      this.chartOptions.battery = batteryChartOptions({
        categories: chartData.categories,
        series1: chartData.battery,
        series2: chartData.battery2,
        errors: chartData.batteryErrors,
      });
      this.chartOptions.rssi = RSSIChartOptions(chartData.rssi, this.rssiUnit);
      this.chartOptions.stream = StreamProfileChartOptions(chartData.stream);
    },
  },
};
</script>

<style scoped></style>
